import { ReactElement } from 'react';
import styles from './CasFormFileInfo.module.scss';
import { VdsCard, VdsIconButton } from '@volt/volt-extended-components-react';
import { useTranslation } from 'react-i18next';

export interface CasFormFileInfoProps {
  name: string;
  size: number;
  disabled?: boolean;
  onRemove: () => void;
}

export const CasFormFileInfo = ({
  name,
  size,
  disabled,
  onRemove,
}: CasFormFileInfoProps): ReactElement => {
  const { t } = useTranslation();
  const megabytes = (size / 1024 / 1024).toFixed(1);

  return (
    <VdsCard className={styles.fileinfo__card} disabled={disabled}>
      <div className={styles.fileinfo__container}>
        <div className={styles.fileinfo__name}>{t('FileDescriptor', { name, megabytes })}</div>
        <VdsIconButton icon="trash" onClick={onRemove} disabled={disabled} />
      </div>
    </VdsCard>
  );
};

export default CasFormFileInfo;
